import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "../../AxiosConfig";
const VisaExpiryList = () => {
    const navigate = useNavigate();
    const [people, setPeople] = useState([]);

    useEffect(() => {
        Axios.post("/employee/visa-expiring", {}).then((response) => {
            setPeople(response.data.data);
        });
    }, []);
    return (
        <div>
            {people.length > 0 && (
                <div className="bg-white rounded-lg border p-6">
                    <p className="text-base font-semibold leading-6 text-gray-900">Visa(s) Expiring in 30 Days</p>

                    <table className="min-w-full divide-y divide-gray-300">
                        <thead>
                            <tr>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                    Name
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Designation
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Department
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                    Visa Expiry Date
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {people.map((person) => (
                                <tr key={person.email}>
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                        <span
                                            className="cursor-pointer text-blue-600 hover:text-blue-500"
                                            onClick={() => {
                                                navigate(`/employees/${person.uuid}`);
                                            }}
                                        >
                                            {person.name}
                                        </span>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.designation}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.department}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {new Date(person.visaExpiresDate).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )
            }
        </div>
    );

};

export default VisaExpiryList;